import { useCurrentActivities, useCurrentActivity } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import { ActivityEditProps } from "./screens"
import { ArchiveButton, CancelButton } from "@hydrologiq/shared/content/components/Button"
import { HStack, VStack, Text } from "@chakra-ui/react"
import { useMutationWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import ActivityScreenWrapper from "./ActivityScreenWrapper"
import ActivityLoading from "./ActivityLoading"
interface ActivityDeleteProps extends ActivityEditProps { }

const ActivityDelete = ({ onBack, onClose }: ActivityDeleteProps) => {
  const activity = useCurrentActivity()
  const activities = useCurrentActivities()
  if (!activity || !activities) {
    return <ActivityLoading />
  }

  const [deleteActivity, { loading: deleteLoading }] = useMutationWithEndpoint(gqlTypes.DeleteActivityDocument, {
    refetchQueries: ["GetSuggestedFulfilments", "AssetAvailabilityCalendar"],
    awaitRefetchQueries: true,
  }, "primary")

  const handleDeleteActivity = async () => {
    await deleteActivity({ variables: { activity: activity.id } }).then(() => {
      onClose()
    })
  }

  return (
    <ActivityScreenWrapper>
      <VStack gap={4} align="stretch" width="100%">
        <Text>Are you sure you want to delete this activity? This action cannot be undone.</Text>
        <HStack gap={2} justify="flex-end">
          <CancelButton
            onClick={onBack}
            disabled={deleteLoading}
            description="Cancel the deletion of the current activity"
          />
          <ArchiveButton
            onClick={handleDeleteActivity}
            disabled={deleteLoading}
            context={{ description: "Delete the current activity", label: "Delete Activity", variant: "warning" }}
          />
        </HStack>
      </VStack>
    </ActivityScreenWrapper>
  )
}

export default ActivityDelete
